import ShortUniqueId from 'short-unique-id';
import { getHeaders } from "../utils";

export async function APIGetCompanyData(companyId) {
  try {
    if (companyId === undefined) {
      return null;
    }

    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/company/${companyId}`,requestOptions, );
    const responseObject = await response.json();
    const company = responseObject.data;

    if (company.length > 0) {
      return await company[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APICreateCompany(companyId, type, email) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const companyName = new ShortUniqueId();

    const raw = JSON.stringify({
      companyId: companyId,
      name: companyName.rnd(),
      email: email,
      details: {
        address: {
          street: ' ',
          zipCode: ' ',
          city: ' ',
          country: ' ',
        },
        phoneNumber: ' ',
      },
      status: 'active',
      type,
    });

    var requestOptions = {
      method: 'POST',
      headers: headers,
      body: raw,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/company`, requestOptions);
    const responseObject = await response.json();
    const company = responseObject.data;

    if (company) {
      return company;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetCompanyAssociates = async (companyId) => {
  try {

    if (companyId === undefined) {
      return null;
    }

    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(
      `${apiUrl}/company/1.0/company/${companyId}/associates`,
      requestOptions,
    );
    const responseObject = await response.json();
    const associates = responseObject.data;

    if (associates.length > 0) {
      return associates;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

export const APIRemoveAccessFromCompany = async (companyId, associateToRemove) => {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'DELETE',
    headers: headers,
    redirect: 'follow',
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/company/${companyId}/accessremove/${associateToRemove}`, requestOptions);

    return response.status === 200;

  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}

export const APIChangeUserAccess = async (companyId, associateToChange, permission) => {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'PUT',
    headers: headers,
    redirect: 'follow',
    body: JSON.stringify({
      permission,
    }),
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/company/${companyId}/changeAccess/${associateToChange}`, requestOptions);

    return response.status === 200;

  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}

export async function APIUpdateCompany(companyData, companyId) {
  try {
    if (!companyId || !companyData) {
      return null;
    }

    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    var raw = JSON.stringify(companyData);

    var requestOptions = {
      method: 'PUT',
      headers: headers,
      body: raw,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(
      `${apiUrl}/company/1.0/company/${companyId}`,
      requestOptions,
    );

    return response.status === 200;

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetCompanyUsers = async (companyId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/company/${companyId}/users`, requestOptions);
    const responseObject = await response.json();
    const users = responseObject.data;

    if (users.length > 0) {
      return await users;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const APIGetCompanyAccess = async (companyId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/company/1.0/companies/${companyId}/access`, requestOptions);
    const responseObject = await response.json();
    const access = responseObject.data;

    return access;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}